export const AI = ["Chat-gpt", "Google Gemini", "MS Bing", "Naver Clova", 'Claude']

export const Translator = [
    "Google Translate",
    "Chat-gpt",
    "Gemini",
    "DeepL",
    "WordVice",
    "Naver Papago",
    "Systran",
]

export const boxType = [
    {label: "형태 선택", key: "notSelected"},
    {label: "라디오 버튼", key: "radio"},
    {label: "체크박스", key: "check"},
    {label: "한줄 텍스트 박스", key: "shortTB"},
    {label: "여러줄 텍스트 박스", key: "longTB"},
]

export const options = [
    {label: "객관식", key: "mulCho"},
    {label: "OX", key: "ox"},
    {label: "단답형", key: "short"},
    {label: "설문(단일선택)", key: "surveySingle"},
    {label: "설문(다중선택)", key: "surveyMulti"},
]